module.exports = __webpack_public_path__ + "static/result-success.aa39928b.png";